import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=250b3b52&"
import script from "./CustomTable.vue?vue&type=script&lang=js&"
export * from "./CustomTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports